import React from "react";
import { useSearchParams } from "react-router-dom";
import { Phone, Mail, MessageCircle, Calendar, MapPin, Download } from "lucide-react";
import Layout from "@/components/layout/Layout";
import LeadForm from "@/components/forms/LeadForm";
import { WHATSAPP, CALENDLY } from "@/lib/api";
import { openExternal } from "@/lib/openExternal";

const TITLES = {
  demo: { eyebrow: "Schedule a Live Demo", title: "See the MBESS in action." },
  quote: { eyebrow: "Request a Quotation", title: "Get a tailored MBESS proposal." },
  investor: { eyebrow: "Investor Relations", title: "Connect with our founders." },
  career: { eyebrow: "Apply to Join Tratou", title: "Tell us about you." },
  contact: { eyebrow: "Talk to an Energy Strategist", title: "Power your project. Anywhere." },
};

export default function Contact() {
  const [sp] = useSearchParams();
  const intent = sp.get("intent") || "contact";
  const t = TITLES[intent] || TITLES.contact;
  const waHref = `https://wa.me/${WHATSAPP.replace(/[^0-9]/g, "")}`;

  return (
    <Layout>
      <section className="py-28 border-b border-white/10" data-testid="contact-hero">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <span className="eyebrow">{t.eyebrow}</span>
          <h1 className="heading-massive mt-4">{t.title}</h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-3 gap-10">
          <div className="lg:col-span-1 space-y-6">
            <InfoBlock icon={MapPin} title="Headquarters" body={"Tratou Energy powered by Tratou Commercial Brokers CO LLC\n114-66, Hamsah Building, Zabeel Street\nDubai, United Arab Emirates"} />
            <InfoBlock icon={Mail} title="Email" body="info@tratouenergy.com" />
            <InfoBlock icon={Phone} title="Phone" body={WHATSAPP} />

            <div className="panel p-6">
              <p className="eyebrow mb-4">Quick Channels</p>
              <div className="flex flex-col gap-3">
                <a href={waHref} target="_blank" rel="noreferrer" onClick={(e) => openExternal(e, waHref)} className="btn-secondary justify-center" data-testid="contact-whatsapp">
                  <MessageCircle className="w-4 h-4 text-tratou-green" /> WhatsApp Now
                </a>
                <a href={CALENDLY} target="_blank" rel="noreferrer" onClick={(e) => openExternal(e, CALENDLY)} className="btn-secondary justify-center" data-testid="contact-calendly">
                  <Calendar className="w-4 h-4 text-tratou-green" /> Book on Calendly
                </a>
                <a href={`tel:${WHATSAPP}`} className="btn-secondary justify-center" data-testid="contact-call">
                  <Phone className="w-4 h-4 text-tratou-green" /> Call Now
                </a>
                <a href="/downloads/tratou-catalog.pdf" target="_blank" rel="noreferrer" onClick={(e) => openExternal(e, "/downloads/tratou-catalog.pdf")} className="btn-secondary justify-center" data-testid="contact-brochure">
                  <Download className="w-4 h-4 text-tratou-green" /> Download Brochure
                </a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <LeadForm source={intent} />
          </div>
        </div>
      </section>
    </Layout>
  );
}

function InfoBlock({ icon: Icon, title, body }) {
  return (
    <div className="panel p-6">
      <Icon className="w-5 h-5 text-tratou-green mb-3" />
      <p className="eyebrow-dim">{title}</p>
      <p className="mt-2 text-white whitespace-pre-line">{body}</p>
    </div>
  );
}
